<!--  -->
<template>
    <div class="formDialog" :class="{'show': show}">
        <div class="content">
            <div class="form_item" v-for="(item, index) in formlist" :key="index">
                <p class="colname" :class="{'require': item.isnotnull}">{{item.colname}}</p>
                <van-field v-model="item.colvalue" v-if="item.coltype === 1" :placeholder="`请输入${item.colname}`" />
                <van-radio-group v-model="item.colvalue" v-else-if="item.coltype === 6">
                    <van-radio :name="options" v-for="(options, i) in item.optionsinfo" :key="i">{{options}}</van-radio>
                </van-radio-group>
                <van-checkbox-group v-model="item.colvalue" v-else-if="item.coltype === 7">
                    <van-checkbox shape="square" :name="options" v-for="(options, i) in item.optionsinfo" :key="i">{{options}}</van-checkbox>
                </van-checkbox-group>
                <div class="picker" v-else-if="item.coltype === 8">
                    <van-field :right-icon="require('@/common/images/index/icon-right.png')" readonly clickable :placeholder="`请选择${item.colname}`" :value="item.colvalue" @click="showPicker(index)"/>
                    <van-popup v-model="item.showPicker" round position="bottom">
                        <van-picker v-model="item.colvalue" :name="String(index)" show-toolbar :columns="item.optionsinfo" @confirm="confirmPicker" @cancel="item.showPicker = false"/>
                    </van-popup>
                </div>
            </div>
        </div>
        <div class="btn">
            <van-button class="return" @click="hideDialog">返回</van-button>
            <van-button class="sumbit" @click="submitMsg">提交信息</van-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            formlist: [],
            show: false,
            showPickerIndex: 0
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        confirmPicker(value) {
            const obj = this.formlist[this.showPickerIndex]
            obj.colvalue = value
            obj.showPicker = false
            this.formlist[this.showPickerIndex] = obj
            console.log(this.formlist[this.showPickerIndex])
            // console.log(e)
        },
        showPicker(index) {
            this.showPickerIndex = index
            this.formlist[index].showPicker = true
        },
        open(list) {
            if (!this.formlist.length) {
                let formlist = JSON.parse(JSON.stringify(list))
                formlist.forEach((item) => {
                    if (item.coltype === 1 || item.coltype === 6 || item.coltype === 8) {
                        item.colvalue = ''
                    } else {
                        item.colvalue = []
                    }
                    if (item.coltype !== 1) {
                        item.optionsinfo = item.optionsinfo.split(',')
                    }
                    if (item.coltype === 8) {
                        item.showPicker = false
                    }
                })
                this.formlist = formlist
                console.log(this.formlist)
            }
            this.show = true
        },
        submitMsg() {
            let flag = true
            this.formlist.some((item) => {
                if (item.isnotnull === 1) {
                    if (!item.colvalue.length) {
                        this.$toast.fail(`${item.colname}为必填`)
                        flag = false
                        return true
                    }
                }
            })
            console.log(this.formlist)
            if (flag) {
                const arr = []
                this.formlist.forEach((obj) => {
                    const colinnerid = obj.colinnerid
                    let colvalue = ''
                    if (obj.coltype === 7) {
                        colvalue = obj.colvalue.join(',')
                    } else {
                        colvalue = obj.colvalue
                    }
                    arr.push({colinnerid, colvalue})
                })
                this.$emit('fillInOver', arr)
                this.show = false
            }
        },
        hideDialog() {
            this.show = false
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .formDialog {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        width: 100%;
        height: 100%;
        transform: translate3d(100%, 0, 0);
        transition: all 0.3s;
        background: #F5F7FA;
        z-index: 10;
        // padding-bottom: 1.1rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        &.show {
            transform: translate3d(0, 0, 0);
        }
        .content {
            flex: 1;
            overflow: scroll;
        }
        .form_item {
            padding: 0 0.32rem 0.32rem;
            background: #fff;
            &:first-of-type {
                padding-top: 0.32rem
            }
            .colname {
                font-size: 0.3rem;
                color: #333333;
                line-height: 0.42rem;
                margin-bottom: 0.28rem;
                &.require::after {
                    content: '*';
                    color: #FF4747;
                    margin-left: 0.05rem;
                    font-size: 0.3rem;
                }
            }
            .van-field {
                padding: 0 0 0.32rem 0;
                border-bottom: 0.01rem solid #EEEEEE;
            }
            .van-radio-group, .van-checkbox-group {
                padding-bottom: 0.32rem;
                border-bottom: 0.01rem solid #EEEEEE;
            }
            .van-radio-group {
                .van-radio {
                    &:not(:last-of-type) {
                        margin-bottom: 0.4rem;
                    }
                    .van-icon {
                        border-color: #409EFF;
                    }
                }
            }
            .van-checkbox-group {
                .van-checkbox {
                    &:not(:last-of-type) {
                        margin-bottom: 0.4rem;
                    }
                    .van-icon {
                        border-color: #409EFF;
                    }
                }
            }
            &:last-of-type {
                padding-bottom: 0;
                .van-radio-group, .van-checkbox-group, .van-field {
                    border-bottom: none;
                }
            }
        }
        .btn {
            width: 100%;
            height: 1rem;
            background: #fff;
            // position: fixed;
            bottom: 0rem;
            left: 0rem;
            padding: 0.15rem 0.28rem;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-around;
            margin-top: 0.1rem;
            .van-button {
                width: 3.3rem;
                height: 0.7rem;
                border-radius: 0.38rem;
                font-size: 0.3rem;
                line-height: 0.7rem;
                padding: 0;
            }
            .return {
                background: #e5e5e5;
                color: #999999;
            }
            .sumbit {
                background: #409EFF;
                color: #fff;
            }
        }
    }
</style>